/* eslint-disable import/no-anonymous-default-export */
import { useAppSelector } from '../store/hooks'
import { cohortsRepository } from '@/repositories'

function useGetCohortsUser() {
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const { data, isLoading, isSuccess } = cohortsRepository.useGetCohortsQuery(
		{
			userId: user?.id || 0,
		},
		{ skip: !user?.id }
	)

	return { data, isLoading, isSuccess }
}

function useGetProgressChecksCohort() {
	const {
		matriculate: { classSelect },
		auth: { user },
	} = useAppSelector((state) => state)

	const turmaId = classSelect?.id || 0
	const isActiveTurma = Array.isArray(user?.turmas)
		? user?.turmas?.some(
				(turma) => turma.id === turmaId && (turma.status || '').toUpperCase() !== 'INATIVO'
		  )
		: false

	const { data, isLoading } = cohortsRepository.useGetProgressCheckQuery(
		{
			cohortId: turmaId,
		},
		{ skip: !turmaId || !isActiveTurma }
	)

	return { data, isLoading }
}

function useGetMatriculate() {
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const { data, isLoading } = cohortsRepository.useGetMatriculateQuery({
		userId: user?.id || 0,
	})

	return { data, isLoading }
}

function useGetMatriculateCompleted() {
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const { data, isLoading } = cohortsRepository.useGetMatriculateCompletedQuery(
		{
			userId: user?.id || 0,
		}
	)

	return { data, isLoading }
}

function useMatriculateRecordedMutation() {
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const [_matriculate, { data, isLoading, isSuccess, isError }] =
		cohortsRepository.useMatriculateRecordedMutation()

	async function execute({ cohortId }: { cohortId: number }) {
		try {
			await _matriculate({ cohortId, userId: user?.id || 0 })
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess, isError }
}

function useSaveProgressCheckAttemptsMutation() {
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const [_saveAttempt, { data, isLoading, isSuccess, isError }] =
		cohortsRepository.useSaveAttemptMutation()

	async function execute(body: {
		progress_check_id: number
		data_tentativa: string
		nota: number
		user_id?: number
	}) {
		try {
			const updatedBody = {
				...body,
				user_id: user?.id,
			}

			await _saveAttempt(updatedBody).unwrap()
		} catch (error) {
			throw error
		}
	}

	return { execute, data, isLoading, isSuccess, isError }
}

export default {
	getCohortsUser: useGetCohortsUser,
	getMatriculate: useGetMatriculate,
	getMatriculateCompleted: useGetMatriculateCompleted,
	getProgressChecks: useGetProgressChecksCohort,
	matriculateRecorded: useMatriculateRecordedMutation,
	saveProgressCheckAttempts: useSaveProgressCheckAttemptsMutation,
}
